import * as Yup from 'yup';
import { ValidationError } from 'yup';
import * as Errors from './errors';
import { LinkableErrorMessageProps } from '@mo/page-error-box/dist/PageErrorBox';

type ErrorType = { [path: string]: string[] };

export type ForgotPasswordData = {
    username?: string;
};

const mapSchemaErrors = (e: ValidationError): ErrorType =>
    e.inner.reduce((errors: ErrorType, error: ValidationError): ErrorType => {
        if (error.path === undefined) {
            return errors;
        }
        const message = errors[error.path] || [];
        return {
            ...errors,
            [error.path]: message.concat(error.message),
        };
    }, {});

/*    
const validationSchema = Yup.object()
    .shape({
        username: Yup.string()
            .nullable(true)
            .required(Errors.BLANK_USERNAME)
            .test('emailInUsername', Errors.EMAIL_AS_USERNAME, function (value) {
                return value ? !value.includes('@') : true;
            }),
    })
    .defined();
*/

const validationSchema = Yup.object()
    .shape({
        username: Yup.string()
            .nullable(true)
            .required(Errors.BLANK_USERNAME)
            .test('usernameInEmail', Errors.USERNAME_AS_EMAIL, function (value) {
                return value ? value.includes('@') : true;
            }),
    })
    .defined();

export const validate = (data: ForgotPasswordData): Promise<ForgotPasswordData> => {
    return validationSchema.validate(data, { abortEarly: false }).catch(
        (e: ValidationError): ForgotPasswordData => {
            throw mapSchemaErrors(e);
        }
    );
};

export const mapPageValidationErrors = (validationErrors: { [key: string]: string[] }): LinkableErrorMessageProps[] => {
    return validationErrors.username
        ? validationErrors.username.map((error): LinkableErrorMessageProps => ({ label: 'Username', message: error }))
        : [];
};
